<section class="transcript">
  <header class="transcript__head">
    <div class="transcript__search">
      <app-search
        [realTime]="true"
        [placeholder]="'Buscar na transcrição'"
        (sendSearch)="buscar($event)" />
      @if (termo().trim()) {
        <span class="transcript__matches" aria-live="polite">
          @if (ocorrencias().length) {
            {{ ocorrenciaAtual() + 1 }} de {{ ocorrencias().length }}
          } @else {
            Nenhuma ocorrência
          }
        </span>
        <button
          type="button"
          class="transcript__nav"
          aria-label="Ocorrência anterior"
          [disabled]="!ocorrencias().length"
          (click)="andar(-1)">
          <i class="pi pi-chevron-up" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          class="transcript__nav"
          aria-label="Próxima ocorrência"
          [disabled]="!ocorrencias().length"
          (click)="andar(1)">
          <i class="pi pi-chevron-down" aria-hidden="true"></i>
        </button>
      }
    </div>
    @if (temVideo()) {
      <button
        type="button"
        class="transcript__follow"
        [class.transcript__follow--on]="seguirVideo()"
        [attr.aria-pressed]="seguirVideo()"
        title="A lista acompanha o vídeo e destaca a fala que está tocando"
        (click)="seguirVideo.set(!seguirVideo())">
        <span class="transcript__follow-track" aria-hidden="true"><span></span></span>
        Seguir o vídeo
      </button>
    }
  </header>

  <ol class="transcript__list" #lista>
    @for (fala of falasNaTela(); track fala.indice) {
      <li
        class="transcript__item"
        [attr.data-fala]="fala.indice"
        [class.transcript__item--playing]="fala.indice === falaAtual()"
        [class.transcript__item--match]="ehOcorrenciaAtual(fala.indice)">
        <div class="transcript__meta">
          <strong>{{ fala.quem }}</strong>
          @if (temVideo() && fala.segundos !== null) {
            <button
              type="button"
              class="transcript__time"
              [title]="'Ir para ' + fala.tempo + ' no vídeo'"
              (click)="ir(fala)">
              {{ fala.tempo }}
            </button>
          } @else {
            <span class="transcript__time transcript__time--static">{{ fala.tempo }}</span>
          }
        </div>
        <p class="transcript__text">
          @for (parte of fala.partes; track $index) {
            @if (parte.destaque) {
              <mark>{{ parte.texto }}</mark>
            } @else {
              {{ parte.texto }}
            }
          }
        </p>
      </li>
    }
  </ol>
</section>
